import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/NotFound.css';

const NotFound = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="notfound-bg">
            <div className="notfound-overlay" />
            <div className="notfound-content">
                <h1 className="notfound-title">404</h1>
                <h2 className="notfound-subtitle">{t('notfound.title')}</h2>
                <p className="notfound-desc">{t('notfound.desc')}</p>
                <button className="notfound-btn" onClick={() => navigate('/')}>{t('notfound.btn')}</button>
            </div>
        </div>
    );
};

export default NotFound; 